import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Store } from '../../store';
import { User } from '../../core/models/User';
import {isNil} from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard  {

  constructor(private store: Store) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.store.select<User>('user').pipe(
      filter((user: User) => !isNil(user)),
      map((user: User) => isNil(user) ? false : user.isSuperAdmin
    ));
  }
}
